import AreaCreate from './Create';
import AreaEdit from './Edit';
import AreaList from './List';
import AreaShow from './Show';
import ExploreIcon from '@mui/icons-material/Explore';
export default {
    create: AreaCreate,
    edit: AreaEdit,
    list: AreaList,
    show: AreaShow,
    recordRepresentation: 'name.en',
    icon: ExploreIcon,
};
